import { render, staticRenderFns } from "./show.content-sections.page.vue?vue&type=template&id=2de13afb&scoped=true&"
import script from "./show.content-sections.page.vue?vue&type=script&lang=js&"
export * from "./show.content-sections.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de13afb",
  null
  
)

export default component.exports